{
  "alert": "Hälytys",
  "dismiss": "Hylkää"
}